/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string | undefined} email
 * @returns {Promise<boolean>}
 */
export async function isEmailAllowlisted(supabase, email) {
  if (!email) return false;
  const { data, error } = await supabase
    .from("allowed_users")
    .select("email")
    .eq("email", email.trim().toLowerCase())
    .eq("active", true)
    .maybeSingle();
  if (error) {
    console.error("allowlist check failed", error);
    return false;
  }
  return Boolean(data);
}
